// import { useState } from "react";
// import { toast } from "react-toastify";
// import { createSubscriptionApi } from "../../apis/subscriptionApi";

// export const useCreateSubscription = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const createNewSubscription = async (subscriptionData) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Creating subscription...");

//     try {
//       const response = await createSubscriptionApi(subscriptionData);

//       toast.update(toastId, {
//         render: "Subscription created successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return response;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to create subscription";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { createNewSubscription, loading, error };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { createSubscriptionApi } from "../../apis/subscriptionApi";

export const useCreateSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message || "Failed to create subscription.",
    };
  };

  const createNewSubscription = async (subscriptionData) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Creating subscription...");

    try {
      const response = await createSubscriptionApi(subscriptionData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Subscription Created</strong>
            <div>Subscription created successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return response;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { createNewSubscription, loading, error };
};